export type BrandMapping = {
  AC: string;
  AH: string;
  AP: string;
  AR: string;
  DS: string;
  FO: string;
  FT: string;
  JE: string;
  LA: string;
  OV: string;
};

export const brandMapping: BrandMapping = {
  AC: 'Citroen',
  AH: 'Abarth',
  AP: 'Peugeot',
  AR: 'AlfaRomeo',
  DS: 'DS',
  FO: 'Fiat',
  FT: 'Fiat',
  JE: 'Jeep',
  LA: 'Lancia',
  OV: 'Opel'
};

export const isBrandKey = (key: string): key is keyof BrandMapping =>
  key in brandMapping;

export const getMappedBrandName = (brandName?: string): string =>
  brandName && isBrandKey(brandName)
    ? brandMapping[brandName]
    : brandName || 'AlfaRomeo';
